"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const bridge_1 = require("@completeanatomy/bridge");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const Card_1 = __importDefault(require("../../atoms/Card"));
const mediaQuery_1 = require("../../cssMixins/mediaQuery");
const hooks_1 = require("../../hooks");
const useSearchProvider_1 = require("../../hooks/useSearchProvider");
const molecules_1 = require("../../molecules");
const Landmark_1 = __importDefault(require("../../molecules/Landmark"));
const react_1 = require("react");
const styled_components_1 = __importStar(require("styled-components"));
// eslint-disable-next-line max-lines-per-function
function SearchPanel({ isOpen, onClose, onClickSpots }) {
    const { t } = (0, i18n_1.useTranslation)();
    const search = (0, useSearchProvider_1.useSearchProvider)();
    const screenInfo = (0, hooks_1.useScreenInfo)();
    const bridge = (0, bridge_1.useBridge)();
    const isLower = (0, ui_1.useScreenBreakpoint)(mediaQuery_1.size.tablet);
    const { i18n } = (0, i18n_1.useTranslation)();
    const [searchResult, setSearchResult] = (0, react_1.useState)(null);
    const [currentTab, setCurrentTab] = (0, react_1.useState)(undefined);
    const [selectedCid, setSelectedCid] = (0, react_1.useState)(null);
    const onChange = (value) => __awaiter(this, void 0, void 0, function* () {
        var _a;
        if (!screenInfo || !search || !value || value.length < 3) {
            setSearchResult(null);
            return;
        }
        const list = yield search.getList(value, screenInfo.model_identifier || '', ((_a = screenInfo.model_version) === null || _a === void 0 ? void 0 : _a.toString()) || '', i18n.language);
        setSearchResult(list);
        setCurrentTab(list.availableTabs.length === 1 ? list.availableTabs[0] : undefined);
    });
    const onChangeTab = (tabType) => {
        setCurrentTab(tabType);
    };
    const isStructureAvailable = !currentTab ||
        currentTab === bridge_schema_1.SearchContentType.Structures ||
        currentTab === bridge_schema_1.SearchContentType.Clusters;
    const isLandmarksAvailable = !currentTab ||
        currentTab === bridge_schema_1.SearchContentType.Spots ||
        currentTab === bridge_schema_1.SearchContentType.Shapes;
    const landMarkTitle = !currentTab
        ? t(i18n_1.Strings.search.tabs.landmarks).toUpperCase()
        : undefined;
    const structureTitle = !currentTab
        ? t(i18n_1.Strings.search.tabs.structures).toUpperCase()
        : undefined;
    const onClickItem = (cid, type) => {
        return () => {
            if ([
                bridge_schema_1.SearchContentType.Medias,
                bridge_schema_1.SearchContentType.Spots,
                bridge_schema_1.SearchContentType.Shapes,
            ].includes(type)) {
                onClickSpots(cid.toString());
            }
            setSelectedCid(cid);
            bridge === null || bridge === void 0 ? void 0 : bridge.selectCID({
                cid: cid.toString(),
                type: type,
            });
            isLower && onClose();
        };
    };
    const result = searchResult && (searchResult === null || searchResult === void 0 ? void 0 : searchResult.length) > 0;
    const resultOutput = result && (searchResult === null || searchResult === void 0 ? void 0 : searchResult.length) > 1
        ? `${searchResult === null || searchResult === void 0 ? void 0 : searchResult.length} ${t(i18n_1.Strings.search.results.multipleResults).toLowerCase()}`
        : `${searchResult === null || searchResult === void 0 ? void 0 : searchResult.length} ${t(i18n_1.Strings.search.results.oneResult).toLowerCase()}`;
    return ((0, jsx_runtime_1.jsxs)(StyledSearchPanel, { "$isExpand": !!searchResult, "$isVisible": isOpen, children: [(0, jsx_runtime_1.jsxs)(SearchTitle, { children: [(0, jsx_runtime_1.jsx)(SearchTitleText, { children: t(i18n_1.Strings.menu.search) }), (0, jsx_runtime_1.jsx)(StyledCloseButton, { onClick: onClose })] }), (0, jsx_runtime_1.jsx)(StyledSearchField, { onChange: onChange }), searchResult && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Result, { children: result ? resultOutput : t(i18n_1.Strings.search.noResults) }), (0, jsx_runtime_1.jsx)(StyledTabGroup, { onChange: onChangeTab, availableTabs: searchResult.availableTabs, currentTab: currentTab }), (0, jsx_runtime_1.jsxs)(SearchResultContainer, { children: [searchResult.structures.length > 0 && isStructureAvailable && ((0, jsx_runtime_1.jsx)(StyledCard, { title: structureTitle, contentStyle: { padding: '0' }, children: (0, jsx_runtime_1.jsx)(StructureGroup, { children: searchResult.structures.map(structure => ((0, jsx_runtime_1.jsx)(StructureItem, { "$isSelected": selectedCid === structure.cid, children: (0, jsx_runtime_1.jsx)(molecules_1.Structure, { onClick: onClickItem(structure.cid, structure['content_type'][0]), isSelected: selectedCid === structure.cid, title: structure.name, subtitle: structure.sname || '', isCluster: structure['content_type'].includes(bridge_schema_1.SearchContentType.Clusters) }) }, structure.cid))) }) })), searchResult.landMarks.length > 0 && isLandmarksAvailable && ((0, jsx_runtime_1.jsx)(StyledCard, { title: landMarkTitle, contentStyle: { padding: '0' }, children: (0, jsx_runtime_1.jsx)(LandMarkGroup, { children: searchResult.landMarks.map(landmark => ((0, jsx_runtime_1.jsx)(LandMarkItem, { "$isSelected": selectedCid === landmark.cid, children: (0, jsx_runtime_1.jsx)(Landmark_1.default, { onClick: onClickItem(landmark.cid, landmark['content_type'][0]), isSelected: selectedCid === landmark.cid, title: landmark.name, subtitle: landmark.sname || '' }) }, landmark.cid))) }) }))] })] }))] }));
}
exports.default = SearchPanel;
const StructureItem = styled_components_1.default.div `
  width: 100%;

  &:hover {
    background-color: ${({ theme }) => theme.grasshopper.search.hover};
  }

  background-color: ${({ theme, $isSelected }) => $isSelected ? theme.grasshopper.search.selected : 'transparent'};
`;
const LandMarkItem = styled_components_1.default.div `
  width: 100%;

  &:hover {
    background-color: ${({ theme }) => theme.grasshopper.search.hover};
  }

  background-color: ${({ theme, $isSelected }) => $isSelected ? theme.grasshopper.search.selected : 'transparent'};
`;
const StyledSearchPanel = styled_components_1.default.div `
  display: ${({ $isVisible }) => ($isVisible ? 'flex' : 'none')};
  position: absolute;
  top: 64px;
  left: 8px;

  flex-direction: column;
  box-sizing: border-box;

  width: 480px;
  max-height: calc(100vh - 64px);

  z-index: 11;

  padding: ${({ $isExpand }) => $isExpand ? '8px 8px 8px 16px' : '4px 8px 4px 8px'};

  ${mediaQuery_1.device.tablet((0, styled_components_1.css) `
    width: calc(100vw - 16px);
    max-height: calc(100vh - 8px);
    top: 8px;
    left: 8px;
  `)}

  background: ${({ theme }) => theme.designSystem.contentBackground};

  border-radius: 4px;
`;
const StyledCloseButton = (0, styled_components_1.default)(ui_1.CloseButton) `
  width: 24px;
  height: 24px;
  margin-left: auto;
`;
const SearchTitle = styled_components_1.default.div `
  margin-top: 8px;
  display: flex;
  width: calc(100% - 16px - 4px);
  margin-left: 4px;
`;
const SearchTitleText = styled_components_1.default.div `
  font-size: 20px;
  color: ${({ theme }) => theme.grasshopper.text.white};
`;
const StyledSearchField = (0, styled_components_1.default)(molecules_1.SearchField) `
  display: inline-table;
  width: calc(100% - 8px);
  border: 0.5px solid ${({ theme }) => theme.grasshopper.borders.monument};
  margin-left: 4px;
  margin-top: 12px;
`;
const StyledTabGroup = (0, styled_components_1.default)(molecules_1.TabGroup) `
  margin-top: 16px;
  margin-right: 12px;
`;
const Result = styled_components_1.default.div `
  font-size: 16px;

  padding: 10px;
  margin-right: 12px;

  color: ${({ theme }) => theme.grasshopper.text.whiteSecondary};
`;
const SearchResultContainer = styled_components_1.default.div `
  height: 100%;

  overflow: -moz-scrollbars-vertical;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    background: transparent;
    width: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.grasshopper.borders.grey};
    border-radius: 6px;
  }

  &::-webkit-scrollbar-button {
    width: 0px;
    height: 8px;
  }
`;
const StructureGroup = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: flex-start;

  justify-content: center;
  gap: 10px;
`;
const LandMarkGroup = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: flex-start;

  justify-content: center;
  gap: 10px;
`;
const StyledCard = (0, styled_components_1.default)(Card_1.default) `
  margin-top: 16px;
  box-sizing: border-box;
`;
